import React, { useEffect, useState, useContext } from 'react';

import DataTable from '../DataTable';
import { UserContext } from '../UserContext';

export default function Filter() {
  const [data, setData] = useState([]);
  const [dataError, setDataError] = useState(false);
  const userContext = useContext(UserContext);
  const baseURL = process.env.REACT_APP_API_BASEURL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${baseURL}/api/admin/all_hours`, {
          headers: {
            Authorization: `${userContext.tokenID}`,
          },
        });
        const data = await response.json();
        setData(data.users || []);
      } catch (error) {
        console.log('Error while fetching from /admin/all_hours', error);
        setDataError(true);
      }
    };
    fetchData();
  }, [baseURL, userContext.tokenID]);

  const makeColumnFilterForCategory = (category, minHours) => ({
    filter: true,
    filterType: 'checkbox',
    filterOptions: {
      names: [
        `Category ${category} incomplete`,
        `Category ${category} complete`,
      ],

      logic(hours, filterVal) {
        const incomplete = filterVal.indexOf(`Category ${category} incomplete`) >= 0;
        const complete = filterVal.indexOf(`Category ${category} complete`) >= 0;

        if (incomplete && complete) {
          // If both are selected, dont show anything as complementary events
          return true;
        }

        const show = (incomplete && hours < minHours) || (complete && hours >= minHours);
        return !show;
      },
    },
  });

  const columns = [
    {
      name: 'email_id',
      options: {
        filter: true,
        filterType: 'checkbox',
        filterOptions: {
          names: ['19 batch', '20 batch', '21 batch', '22 batch', '23 batch'],
          logic(email_id, filterVal) {
            // salary = salary.replace(/[^\d]/g, "");
            const show = (filterVal.indexOf('19 batch') >= 0
                && email_id.substring(2, 4) === '19')
              || (filterVal.indexOf('20 batch') >= 0
                && email_id.substring(2, 4) === '20')
              || (filterVal.indexOf('21 batch') >= 0
                && email_id.substring(2, 4) === '21')
              || (filterVal.indexOf('22 batch') >= 0
                && email_id.substring(2, 4) === '22')
              || (filterVal.indexOf('23 batch') >= 0
                && email_id.substring(2, 4) === '23');
            // const show =
            //   (filterVal.indexOf("Lower wages") >= 0 && salary < 100000) ||
            //   (filterVal.indexOf("Average wages") >= 0 &&
            //     salary >= 100000 &&
            //     salary < 200000) ||
            //   (filterVal.indexOf("Higher wages") >= 0 && salary >= 200000);
            return !show;
          },
        },
        sort: false,
      },
    },
    {
      name: 'Category 1',
      options: makeColumnFilterForCategory('1', 30),
    },
    {
      name: 'Category 2',
      options: makeColumnFilterForCategory('2', 30),
    },
    {
      name: 'Category 3',
      options: makeColumnFilterForCategory('3', 10),
    },
    {
      name: 'Category 4',
      options: makeColumnFilterForCategory('4', 20),
    },
    {
      name: 'Category 5',
      options: { filter: false },
    },
    {
      name: 'Category 6',
      options: { filter: false },
    },
    {
      name: 'Total Hours',
      options: {
        filter: true,
        filterType: 'checkbox',
        filterOptions: {
          names: ['Total incomplete', 'Total complete'],

          logic(hours, filterVal) {
            const incomplete = filterVal.indexOf('Total incomplete') >= 0;
            const complete = filterVal.indexOf('Total complete') >= 0;

            if (incomplete && complete) {
              // If both are selected, dont show anything as complementary events
              return true;
            }

            const show = (incomplete && hours < 120) || (complete && hours >= 120);
            return !show;
          },
        },
      },
    },
  ];

  return (
    <>
      <DataTable
        tableName="All students"
        data={data}
        columns={columns}
        error={dataError}
        options={{
          rowsPerPage: 15,
          // rowsPerPageOptions: [10, 15, 20, 25, 50, 100],
          filter: true,
          filterType: 'checkbox',
          responsive: 'standard',
          setFilterChipProps: (colIndex, colName, data) => {
            console.log(colIndex, colName, data);
            return {
              color: 'primary',
              variant: 'outlined',
              className: 'testClass123',
            };
          },
        }}
      />
    </>
  );
}
